import customersService from './customersService'

export default customersService



// WEBPACK FOOTER //
// ../src/services/customersService/index.js